export const accessTokenKey = 'access';
export const refreshTokenKey = 'refresh';

export const tokenKey = {
  access: accessTokenKey,
  refresh: refreshTokenKey
}